<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <div v-if="loading" style="text-align: center; margin-top: 200px; height: calc(100vh - 50px);">
        <img src="https://s3.amazonaws.com/cdn.ats-ptrac.com/wait-gif/wait-9.gif"/>
        <h3 style="margin-top: 75px;">PTRAC is Loading. Please wait a moment.</h3>

        <div v-if="joke">
          <h6>While you are waiting...</h6>
          <p style="margin-top: 25px;">{{ joke }}</p>
        </div>
      </div>

      <dashboard-content v-else @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
      <modal1 id="modal-1" v-if="showModal1" v-bind="modal1" @close="showModal1 = false"></modal1>
      <modal2 id="modal-2" v-if="showModal2" v-bind="modal2" @close="showModal2 = false"></modal2>
      <modal3 id="modal-3" v-if="showModal3" v-bind="modal3" @close="showModal3 = false"></modal3>
      <modal4 id="modal-4" v-if="showModal4" v-bind="modal4" @close="showModal4 = false"></modal4>
      <modal5 id="modal-5" v-if="showModal5" v-bind="modal5" @close="showModal5 = false"></modal5>
      <modal6 id="modal-6" v-if="showModal6" v-bind="modal6" @close="showModal6 = false"></modal6>
      <modal-lock id="modal-lock" v-if="isPtracApiDown" :message="modalLockMessage"></modal-lock>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import Modal1 from 'src/components/UIComponents/Modal1'
  import Modal2 from 'src/components/UIComponents/Modal2'
  import Modal3 from 'src/components/UIComponents/Modal3'
  import Modal4 from 'src/components/UIComponents/Modal4'
  import Modal5 from 'src/components/UIComponents/Modal5'
  import Modal6 from 'src/components/UIComponents/Modal6'
  import ModalLock from 'src/components/UIComponents/ModalLock'
  import {projectsLinks, jobsLinks, tasksLinks, invoicesLinks, inTouchLinks, adminLinks} from 'src/sidebarLinks'
  import {mapGetters} from 'vuex'
  import Permissions from 'src/utilities/permissions'
  import {defineAbilitiesForUser} from 'src/ability'
  import Constants from 'src/utilities/constants'
  import axios from 'axios'
  import _ from 'lodash'
  import jwtDecode from "jwt-decode"

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      Modal1,
      Modal2,
      Modal3,
      Modal4,
      Modal5,
      Modal6,
      ModalLock
    },
    computed: {
      ...mapGetters({
        user: 'security/user',
        apiHealth: 'apiHealth/services'
      }),
      isPtracApiDown() {
        const ptracApiState = this.apiHealth.ptracApi.state
        return ptracApiState === Constants.HEALTH_CHECK_STATUSES.ERROR
          || ptracApiState === Constants.HEALTH_CHECK_STATUSES.DOWN
      },
      isPtracApiUp() {
        const ptracApiState = this.apiHealth.ptracApi.state
        return ptracApiState === Constants.HEALTH_CHECK_STATUSES.UP
      },
      modalLockMessage() {
        if (this.isPtracApiDown) {
          return 'PTRAC is temporarily down. Enjoy this opportunity to check your email, browse cat memes or take a little break. The nerds have been notified.'
        }
      }
    },
    data () {
      return {
        modal1: {
          title: null,
          component: null,
          data: {}
        },
        modal2: {
          title: null,
          component: null,
          data: {}
        },
        modal3: {
          title: null,
          component: null,
          data: {}
        },
        modal4: {
          title: null,
          component: null,
          data: {}
        },
        modal5: {
          title: null,
          component: null,
          data: {}
        },
        modal6: {
          title: null,
          component: null,
          data: {}
        },
        showModal1: false,
        showModal2: false,
        showModal3: false,
        showModal4: false,
        showModal5: false,
        showModal6: false,
        loading: true,
        joke: ''
      }
    },
    methods: {
      handleShowModal(title, data, width, whichModal) {
        this['modal' + whichModal].title = title
        this['modal' + whichModal].component = title.replace(/&/g, '').split(' ').join('-').toLowerCase()
        this['modal' + whichModal].data = data
        this['modal' + whichModal].width = width
        this['showModal' + whichModal] = true
      },
      handleShowModal1(title, data, width) {
        this.handleShowModal(title, data, width, 1)
      },
      handleShowModal2(title, data, width) {
        this.handleShowModal(title, data, width, 2)
      },
      handleShowModal3(title, data, width) {
        this.handleShowModal(title, data, width, 3)
      },
      handleShowModal4(title, data, width) {
        this.handleShowModal(title, data, width, 4)
      },
      handleShowModal5(title, data, width) {
        this.handleShowModal(title, data, width, 5)
      },
      handleShowModal6(title, data, width) {
        this.handleShowModal(title, data, width, 6)
      },
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      async populateSidebarLinks() {
        if (this.$auth.isAuthenticated) {
          this.$sidebar.sidebarLinks = [] // start from zero

          if (this.$can('read', Permissions.PROJECTS)) {
            this.$sidebar.sidebarLinks.push(projectsLinks())
          }

          const jobMenu = jobsLinks(this.$can)
          if (jobMenu) {
            this.$sidebar.sidebarLinks.push(jobMenu)
          }

          if (this.$can('read', Permissions.TASKS)) {
            this.$sidebar.sidebarLinks.push(tasksLinks())
          }
          if (this.$can('read', Permissions.INVOICES)) {
            this.$sidebar.sidebarLinks.push(invoicesLinks(this.$can))
          }
          if (this.$can('read', Permissions.IN_TOUCH)) {
            this.$sidebar.sidebarLinks.push(inTouchLinks())
          }
          const adminMenu = adminLinks(this.$can)
          if (adminMenu) {
            this.$sidebar.sidebarLinks.push(adminMenu)
          }
        }
      },
      async maybeInitAuthData() {
        if (_.isEmpty(this.user.claims)) {
          this.$store.commit('security/userClaims', this.$auth.user)
          this.$eventHub.$emit('userAuthenticated')
        }
        return await this.$store.dispatch('security/fetchUserData')
      },
      async preloadGlobalDataDependencies() {
        await Promise.all([
          this.$store.cache.dispatch('config/fetchAll'),
          this.$store.cache.dispatch('departments/fetchAll'),
          this.$store.cache.dispatch('tasks/names/fetchAll'),
          this.$store.cache.dispatch('tasks/templates/fetchAll'),
          this.$store.cache.dispatch('users/fetchAll'),
          this.$store.cache.dispatch('users/fetchAllPreferences')
        ])
        this.loading = false
      },
      goLogin() {
        if (this.$route.path !== '/login') {
          this.$router.push('/login')
        }
      },
      async logout() {
        await this.$store.dispatch('security/logout')
        await this.$auth.logout({
          postLogoutRedirectUri: process.env.VUE_APP_OIDC_REDIRECT_URI,
          revokeAccessToken: true,
          revokeRefreshToken: true
        })
      },
      async waitForAuthToLoad() {
        const timeoutMs = 5000
        const pollInterval = 50
        let waited = 0

        while (this.$auth.loading) {
          if (waited >= timeoutMs) {
            console.warn('Auth check timed out — continuing anyway.')
            break
          }
          await new Promise(r => setTimeout(r, pollInterval))
          waited += pollInterval
        }
      },
      fetchJoke() {
        const self = this
        axios.get('https://icanhazdadjoke.com', { headers: { 'Accept': 'text/plain' }}).then(response => {
          self.joke = response.data
        }).catch(error => {
          console.log('No Joke for You.', error)
        })
      }
    },
    async created() {
      try {
        await this.waitForAuthToLoad()

        if (!this.$auth.isAuthenticated) {
          console.log('NOT Authenticated, go login')
          this.goLogin()
          return
        }
      } catch (e) {
        console.error('Error checking isAuthenticated', e)
        this.goLogin()
      }

      await this.fetchJoke()

      this.$eventHub.$on('go-login', this.goLogin)
      this.$eventHub.$on('logout', this.logout)
      this.$eventHub.$on('ptrac-api-up', this.preloadGlobalDataDependencies)
      this.$eventHub.$on('show-modal-1', this.handleShowModal1)
      this.$eventHub.$on('show-modal-2', this.handleShowModal2)
      this.$eventHub.$on('show-modal-3', this.handleShowModal3)
      this.$eventHub.$on('show-modal-4', this.handleShowModal4)
      this.$eventHub.$on('show-modal-5', this.handleShowModal5)
      this.$eventHub.$on('show-modal-6', this.handleShowModal6)

      await this.$store.dispatch('apiHealth/fetchAll')

      await this.maybeInitAuthData()

      defineAbilitiesForUser(this.$ability, this.user.groups)

      if (this.isPtracApiUp) {
        await this.populateSidebarLinks()
      }
    },
    destroyed() {
      this.$eventHub.$off('show-modal-1')
      this.$eventHub.$off('show-modal-2')
      this.$eventHub.$off('show-modal-3')
      this.$eventHub.$off('show-modal-4')
      this.$eventHub.$off('show-modal-5')
      this.$eventHub.$off('show-modal-6')
      this.$eventHub.$off('ptrac-api-up')
      this.$eventHub.$off('user-groups-loaded')
      this.$eventHub.$off('go-login')
    }
  }

</script>
